import React, { useState } from 'react';
import { ActionSheet } from 'antd-mobile';
import { FormattedMessage } from 'react-intl';
import s from './InquireBtn.module.scss';

/**
 * 移动端咨询按钮组件
 * @param {string} locale - 当前语言环境
 * @param {object} customStyle - 自定义样式
 */
const InquireBtnMobile = ({ locale, customStyle = {} }) => {
  const [visible, setVisible] = useState(false);

  // 判断是否为英文环境
  const isEnglish = locale === 'en-US';

  // 定义动作项
  const getActions = () => {
    if (isEnglish) {
      // 英文环境只显示邮件
      return [
        {
          key: 'email',
          text: (
            <div className={s['inquire-action-item']}>
              <i className={s['inquire-icon-email']} />
              <a 
                href="mailto:bd@qingping.co"
                className={s['inquire-link']}
              >
                bd@qingping.co
              </a>
            </div>
          ),
        },
      ];
    } else {
      // 中文环境显示电话和邮件
      return [
        {
          key: 'phone',
          text: (
            <div className={s['inquire-action-item']}>
              <i className={s['inquire-icon-tel']} />
              <span className={s['inquire-text']}>(010) 8476 6899</span>
            </div>
          ),
        },
        {
          key: 'email',
          text: (
            <div className={s['inquire-action-item']}>
              <i className={s['inquire-icon-email']} />
              <a 
                href="mailto:bd@qingping.co"
                className={s['inquire-link']}
              >
                bd@qingping.co
              </a>
            </div>
          ),
        },
      ];
    }
  };

  const handleAction = (action) => {
    // 如果点击的是邮件项，浏览器会自动处理 mailto 链接
    // 电话项点击后关闭面板即可
    setVisible(false);
  };

  return (
    <>
      <div 
        className={s['inquire-btn-mobile']} 
        onClick={() => setVisible(true)}
        style={customStyle}
      >
        <span className={s['inquire-btn-text']}>
          <FormattedMessage id="inquire_btn" />
        </span>
      </div>

      <ActionSheet
        visible={visible}
        actions={getActions()}
        onClose={() => setVisible(false)}
        onAction={handleAction}
        cancelText={
          <div className={s['inquire-action-item']}>
              <span className={s['inquire-text']}>
                {locale.indexOf('US') > -1 ? 'Cancel' :
                locale.indexOf('TW') > -1 ? '取消' : '取消'}
              </span>
          </div>
        }
      />
    </>
  );
};

export default InquireBtnMobile;

